import { RootSchema } from "../../redux/reducers";
import { AnalyticsEvent } from "./types";
import { mapAppsAnalyticsEvents } from "./mappers/apps";
import { mapAuthenticationAnalyticsEvents } from "./mappers/authentication";
import { mapAuthStudioAnalyticsEvents } from "./mappers/authStudio";
import { mapBrandingAnalyticsEvents } from "./mappers/branding";
import { mapCustomIdpAnalyticsEvents } from "./mappers/customIdp";
import { mapIntegrationsAnalyticsEvents } from "./mappers/integrations";
import { mapMfaAnalyticsEvents } from "./mappers/mfa";
import { mapOrchestrationAnalyticsEvents } from "./mappers/orchestration";
import { mapSecurityAnalyticsEvents } from "./mappers/security";
import { mapSocialAnalyticsEvents } from "./mappers/social";
import { mapTenantAnalyticsEvents } from "./mappers/tenant";
import { mapUsersAnalyticsEvents } from "./mappers/users";

export const getMappedAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapTenantAnalyticsEvents(previousState, currentState),
  ...mapAppsAnalyticsEvents(previousState, currentState),
  ...mapSocialAnalyticsEvents(previousState, currentState),
  ...mapCustomIdpAnalyticsEvents(previousState, currentState),
  ...mapAuthenticationAnalyticsEvents(previousState, currentState),
  ...mapMfaAnalyticsEvents(previousState, currentState),
  ...mapSecurityAnalyticsEvents(previousState, currentState),
  ...mapUsersAnalyticsEvents(previousState, currentState),
  ...mapBrandingAnalyticsEvents(previousState, currentState),
  ...mapOrchestrationAnalyticsEvents(previousState, currentState),
  ...mapIntegrationsAnalyticsEvents(previousState, currentState),
  ...mapAuthStudioAnalyticsEvents(previousState, currentState)
];
